/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventAuthenticationSucceededV1
 */
export interface SDKEventAuthenticationSucceededV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    person_id: string;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    success_authn_method: FactorMethod;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    authenticated_methods: Array<FactorMethod>;
    /**
     * 
     * @type {PersonHandle}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    handle?: PersonHandle;
}



/**
 * Check if a given object implements the SDKEventAuthenticationSucceededV1 interface.
 */
export function instanceOfSDKEventAuthenticationSucceededV1(value: object): value is SDKEventAuthenticationSucceededV1 {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    if (!('success_authn_method' in value) || value['success_authn_method'] === undefined) return false;
    if (!('authenticated_methods' in value) || value['authenticated_methods'] === undefined) return false;
    return true;
}

export function SDKEventAuthenticationSucceededV1FromJSON(json: any): SDKEventAuthenticationSucceededV1 {
    return SDKEventAuthenticationSucceededV1FromJSONTyped(json, false);
}

export function SDKEventAuthenticationSucceededV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventAuthenticationSucceededV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'],
        'success_authn_method': FactorMethodFromJSON(json['success_authn_method']),
        'authenticated_methods': ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'handle': json['handle'] == null ? undefined : PersonHandleFromJSON(json['handle']),
    };
}

export function SDKEventAuthenticationSucceededV1ToJSON(json: any): SDKEventAuthenticationSucceededV1 {
    return SDKEventAuthenticationSucceededV1ToJSONTyped(json, false);
}

export function SDKEventAuthenticationSucceededV1ToJSONTyped(value?: SDKEventAuthenticationSucceededV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_name': EventNameToJSON(value['event_name']),
        'person_id': value['person_id'],
        'success_authn_method': FactorMethodToJSON(value['success_authn_method']),
        'authenticated_methods': ((value['authenticated_methods'] as Array<any>).map(FactorMethodToJSON)),
        'handle': PersonHandleToJSON(value['handle']),
    };
}

